import { render, staticRenderFns } from "./SideDrawer.vue?vue&type=template&id=20c1c742&scoped=true"
import script from "./SideDrawer.vue?vue&type=script&lang=js"
export * from "./SideDrawer.vue?vue&type=script&lang=js"
import style0 from "./SideDrawer.vue?vue&type=style&index=0&id=20c1c742&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c1c742",
  null
  
)

export default component.exports